import { light } from '@fortawesome/fontawesome-svg-core/import.macro';
import React, { Fragment, useContext } from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import DemoCard from '../../assets/demo-card.svg';
import TulipIcon from '../../assets/tulip.svg';
import Blockquote from '../../components/Blockquote';
import Button from '../../components/Button';
import DefaultCard from '../../components/DefaultCard';
import GenericCard from '../../components/GenericCards';
import GenericList, { GenericListItem } from '../../components/GenericList';
import Label from '../../components/Label';
import Link from '../../components/Link';
import OutlinedCard from '../../components/OutlinedCard';
import { PricingCardListItem } from '../../components/PricingCalculatorCard';
import useModal from '../../hooks/useModal';
import { AuthStore } from '../../providers/auth';
import { HssProvider } from '../../providers/hss';
import { TRANSACTION_HISTORY_ROUTE } from '../../routes/types';
import {
  addOrRemoveYearsToGivenDate,
  DateFormats,
  formatDate,
  formatPrice,
  openExternalLink,
} from '../../utils/utils';
import ChangeHSAContributionsModal from '../widgets/changeHSAContributionsModal/ChangeHSAContributionsModal';
import HSATransactionInformationModal from '../widgets/HSATransactionInformationModal/HSATransactionInformationModal';
import SuccessDialog from '../widgets/success/successDialog';

const HSATransactionData = [
  {
    date: formatDate(new Date(), DateFormats.US),
    transaction: 'HSA One-Time Contribution',
    amount: formatPrice(1200.0),
    status: 'Pending',
  },
];

function HealthSavingsAndSpendingChannelView() {
  const [,] = useContext(AuthStore) || [];
  const navigate = useNavigate();

  const [
    showChangeHSAContributionsModal,
    handleShowChangeHSAContributionsModal,
    handleCloseChangeHSAContributionsModal,
  ] = useModal();

  const [
    showHSATransactionModal,
    handleShowHSATransactionModal,
    handleCloseHSATransactionModal,
  ] = useModal();

  const [showSuccessDialog, handleShowSuccessDialog, handleCloseSuccessDialog] =
    useModal();

  const [prePayItems, setPrePayItems] = React.useState<
    Array<PricingCardListItem>
  >([
    {
      text: 'Your New Contributions (Future)',
      value: 500,
    },
    {
      text: 'Company Contributions (Future)',
      value: 115.38,
    },
    {
      text: 'Total Contributions (YTD)',
      value: 2034.62,
    },
  ]);

  const [oneTimeItems, setOneTimeItems] = React.useState<
    Array<PricingCardListItem>
  >([
    {
      text: 'Your New One-Time Contributions',
      value: 100,
    },
    {
      text: 'Your Per-Pay-Period Contribution (Future)',
      value: 150,
    },
    {
      text: 'Company Contributions (Future)',
      value: 115.38,
    },
    {
      text: 'Total Contributions (YTD)',
      value: 2034.62,
    },
  ]);

  const outlinedCardData = [
    {
      title: 'Health Care FSA',
      totalPrice: 2000,
      availablePrice: 399.75,
      yearlyPrice: 1750.75,
    },
    {
      title: 'Dependent Care FSA',
      totalPrice: 5000,
      availablePrice: 2056,
      yearlyPrice: 2750,
    },
  ];

  const firstDayOfTheYear = new Date(new Date().getFullYear(), 0, 1);
  const lastDayOfTheYear = new Date(new Date().getFullYear(), 11, 31);

  const firstDayOfTheLastYear = new Date(
    addOrRemoveYearsToGivenDate(new Date(), -1).getFullYear(),
    0,
    1
  );

  const lastDayOfTheLastYear = new Date(
    addOrRemoveYearsToGivenDate(new Date(), -1).getFullYear(),
    11,
    31
  );

 

  return (
    <Container className={'cnd-custom-container-large mb-12 px-lg-9 px-xl-0'}>
      <Row className={'mt-7 mt-lg-13'}>
        <Col
          sm={12}
          lg={8}
          className={
            'd-flex justify-content-between align-items-center pt-lg-8'
          }
        >
          <h6 className={'h6 fw-normal mb-0'}>{'Health Savings Plan (HSA)'}</h6>
          <Button
            variant="primary-outline"
            rightIcon={light('chevron-right')}
            size="sm"
            onClick={() => {
              openExternalLink('https://www.healthequity.com/demo/member/all-accounts/main-dashboard');
            }}
          >
            Details
          </Button>
        </Col>
      </Row>
      <Row className={'mt-10'}>
        <Col sm={12} lg={8}>
          <GenericCard variant="white" style={{ zIndex: '1000' }}>
            <h4 className={'text-sm-24-lg-32'}>{'Account Balance'}</h4>
            <Row className={'w-100 fw-light m-0'}>
              <Col
                className={'col-12 col-lg-5 mt-7 p-7 p-lg-0 gray-border-mobile'}
              >
                <div className={'text-dark text-sm-12-lg-14'}>
                  {'Available balance'}
                </div>
                <div className={'text-ligther-grey fs-5 mt-4'}>
                  {formatPrice(3464.26)}
                </div>
              </Col>
              <Col
                className={'col-12 col-lg-3 mt-7 p-7 p-lg-0 gray-border-mobile'}
              >
                <div className={'text-dark text-sm-12-lg-14'}>
                  {'Investments'}
                </div>
                <div className={'text-dark-gray fs-5 mt-4'}>
                  {formatPrice(1689.75)}
                </div>
              </Col>
              <Col
                className={'col-12 col-lg-4 mt-7 p-7 p-lg-0 gray-border-mobile'}
              >
                <div className={'text-dark-gray text-sm-12-lg-14 text-lg-end'}>
                  {'Total Value'}
                </div>
                <div className={'text-primary fs-5 mt-4 text-lg-end'}>
                  {formatPrice(5154.01)}
                </div>
              </Col>
            </Row>
            <div className={'text-light-grey text-fs-6 fw-light mt-6'}>
              {`As of ${formatDate(new Date())}`}
            </div>
          </GenericCard>
          <GenericCard style={{ marginTop: '-15px' }}>
            <div
              className={
                'd-flex align-items-center justify-content-between w-100 mt-7 mt-lg-3 mb-1'
              }
            >
              <h4 className={'text-sm-20-lg-24'}>{'Contributions'}</h4>
              <Button
                size={'sm'}
                onMouseDown={handleShowChangeHSAContributionsModal}
              >
                Change
              </Button>
              <ChangeHSAContributionsModal
                showChangeHSAContributionsModal={
                  showChangeHSAContributionsModal
                }
                prePayItems={prePayItems}
                oneTimeItems={oneTimeItems}
                setOneTimeItems={setOneTimeItems}
                setPrePayItems={setPrePayItems}
                handleCloseChangeHSAContributionsModal={
                  handleCloseChangeHSAContributionsModal
                }
                handleShowSuccessDialog={handleShowSuccessDialog}
              />
              <SuccessDialog
                showSuccessDialog={showSuccessDialog}
                handleCloseSuccessDialog={handleCloseSuccessDialog}
              >
                <Container className="p-0 text-center">
                  <p
                    className="p-0 m-0 fw-light success-modal-text"
                    style={{ lineHeight: '21px' }}
                  >
                    HSA Contribution Change submitted.
                    <br /> A copy of the confirmation can be found under
                    Transaction History.
                    <br /> Changes will be applied to the next possible payment
                    processing cycle.
                  </p>
                </Container>
              </SuccessDialog>
            </div>
            <GenericList>
              <GenericListItem>
                <Row className={'w-100'}>
                  <Col
                    className={
                      'col-3 col-lg-5 text-dark-gray text-sm-12-lg-14 fw-normal'
                    }
                  >
                    {'Period'}
                  </Col>
                  <Col className={'col-5 col-lg-3 text-dark text-sm-12-lg-14'}>
                    {'Total Contributions'}
                  </Col>
                  <Col
                    className={
                      'col-4 col-lg-4 text-dark text-sm-12-lg-14 text-end pe-0'
                    }
                  >
                    {'Balance'}
                  </Col>
                </Row>
              </GenericListItem>
              <GenericListItem>
                <Row className={'w-100'}>
                  <Col
                    className={
                      'col-4 col-lg-5 text-dark-gray text-sm-12-lg-14 fw-normal'
                    }
                  >
                    {`${formatDate(new Date(), DateFormats.ONLY_YEAR)} (YTD)`}
                  </Col>
                  <Col
                    className={'col-4 col-lg-3 text-dark-gray text-sm-12-lg-14'}
                  >
                    {formatPrice(1100.0)}
                  </Col>
                  <Col
                    className={
                      'col-4 col-lg-4 text-dark-gray text-sm-12-lg-14 text-end pe-0'
                    }
                  >
                    {formatPrice(41.0)}
                  </Col>
                </Row>
              </GenericListItem>
              <GenericListItem>
                <Row className={'w-100'}>
                  <Col
                    className={
                      'col-4 col-lg-5 text-dark-gray text-sm-12-lg-14 fw-normal'
                    }
                  >
                    {`${formatDate(
                      addOrRemoveYearsToGivenDate(new Date(), -1),
                      DateFormats.ONLY_YEAR
                    )}`}
                  </Col>
                  <Col
                    className={'col-4 col-lg-3 text-dark-gray text-sm-12-lg-14'}
                  >
                    {formatPrice(2000.0)}
                  </Col>
                </Row>
              </GenericListItem>
            </GenericList>
            <div className={'mt-10'}>
              <Blockquote variant="transperant">
                <Fragment>
                  <div className={'text-darker-gray-75'}>
                    <strong>Did you know?</strong>
                  </div>
                  <div className={'mt-2 text-ligther-grey'}>
                    You can set an HSA savings goal to increase money for retirement.{' '}
                    <span className={'d-inline-block'}>
                      <Link className={'py-0'} isBlue onClick={() => {
                        openExternalLink('https://www.mybenefitwallet.com/HSAGoal.html');
                        }}>
                        Get Started
                      </Link>
                    </span>
                  </div>
                </Fragment>
              </Blockquote>
            </div>
          </GenericCard>
        </Col>

        <Col sm={12} lg={4} className={'mt-11 mt-lg-0'}>
          <div>
            <GenericCard variant={'white'} className={'p-10'}>
              <div className={'text-dark-gray text-fs-base fw-normal mb-6'}>
                {'Recent Transactions'}
              </div>
              <GenericList>
                <GenericListItem>
                  <div
                    className={
                      'w-100 d-flex justify-content-between align-items-center'
                    }
                  >
                    <Label
                      className={'cursor-pointer text-blue'}
                      onClick={handleShowHSATransactionModal}
                    >
                      <span className="text-blue">
                        HSA One-Time Contribution
                      </span>
                    </Label>
                    <Label
                      onClick={handleShowHSATransactionModal}
                      leftIcon={light('circle-exclamation')}
                      iconVariant={'danger'}
                    >
                      <span className={'fw-normal'}>Pending</span>
                    </Label>
                    <HSATransactionInformationModal
                      showModal={showHSATransactionModal}
                      handleCloseModal={handleCloseHSATransactionModal}
                      data={HSATransactionData}
                    />
                  </div>
                </GenericListItem>
                <GenericListItem>
                  <div
                    className={
                      'w-100 d-flex justify-content-between align-items-center'
                    }
                  >
                    <Label>{'HSA Per-Pay-Period Change'}</Label>
                    <span className={'ps-3 text-light-grey'}>
                      {'Completed'}
                    </span>
                  </div>
                </GenericListItem>
                <GenericListItem>
                  <span className={'text-light-grey lh-sm'}>
                    {'For all activity check Transaction History.'}
                  </span>
                </GenericListItem>
              </GenericList>
              <div className={'text-end'}>
                <Button
                  size={'sm'}
                  rightIcon={light('list-timeline')}
                  onClick={() => navigate(TRANSACTION_HISTORY_ROUTE)}
                >
                  {'Transaction History'}
                </Button>
              </div>
            </GenericCard>
            
          </div>

          <div className='mt-10'>
          <GenericCard
              onClick={() => openExternalLink('https://www.healthequity.com/demo/member/all-accounts/main-dashboard')}
              className={'doc-upload p-5 cursor-pointer'}
              variant={'white'}
            >
              <div
                className={'carousel-img-container rounded-1 overflow-hidden'}
              >
                <img
                  className={'w-100 h-auto'}
                  src={`${process.env.PUBLIC_URL}/${'company11.png'}`}
                  alt={`${process.env.PUBLIC_URL}/${'company11.png'}`}
                />
              </div>
              <div className="mt-4 lh-xs fw-light">
                <h6 className="mb-0 text-sm-16-lg-20">HealthEquity</h6>
              </div>
              <div className="lh-xxs fw-light text-sub1 text-light-grey-normal">
                <span>View balances, claims, eligible expenses & more</span>
              </div>
            </GenericCard>
            </div>

            

        </Col>
      </Row>

      <Row className={'mt-7 mt-lg-10'}>
        <Col
          sm={12}
          lg={8}
          className={'d-flex flex-column mt-12 mt-lg-0 pt-0 order-2 order-lg-1'}
        >
          <div
            className={
              'd-flex justify-content-between align-items-center w-100 mb-10'
            }
          >
            <h6 className={'h6 fw-normal mb-0'}>
              {'Flexible Spending Account (FSA)'}
            </h6>
            <div className={'d-flex ms-3'}>
              <Button
                variant="primary-outline"
                rightIcon={light('chevron-right')}
                size="sm"
                onClick={() => {
                  openExternalLink('https://www.mybenefitwallet.com/CMS/portal/default/index.html');
                }}
              >
                Details
              </Button>
            </div>
          </div>
          <GenericCard variant="white" style={{ zIndex: '1000' }}>
            <h4 className={'text-sm-24-lg-32'}>{`${formatDate(
              new Date(),
              DateFormats.ONLY_YEAR
            )} Plan Year`}</h4>
            <div
              className={
                'd-flex align-items-center justify-content-between fw-light'
              }
            >
              <span className={'text-light-grey text-fs-6'}>
                {`(${formatDate(
                  firstDayOfTheYear,
                  DateFormats.US
                )} - ${formatDate(lastDayOfTheYear, DateFormats.US)})`}
              </span>
              <span className={'text-light-grey text-fs-6'}>
                {`As of ${formatDate(new Date())}`}
              </span>
            </div>
            <Row>
              {outlinedCardData.map((item, index) => (
                <Col sm={12} lg={6} key={index} className={'mt-7'}>
                  <OutlinedCard cardData={item} />
                </Col>
              ))}
            </Row>
          </GenericCard>
          <GenericCard variant="gray" style={{ marginTop: '-15px' }}>
            <h4 className={'text-sm-20-lg-24 mt-7 mt-lg-3'}>
              {`${formatDate(
                addOrRemoveYearsToGivenDate(new Date(), -1),
                DateFormats.ONLY_YEAR
              )} Plan Year`}
            </h4>
            <div
              className={'d-flex align-items-center justify-content-between'}
            >
              <span className={'text-dark-gray-50 text-fs-6 fw-light'}>
                {`(${formatDate(
                  firstDayOfTheLastYear,
                  DateFormats.US
                )} - ${formatDate(lastDayOfTheLastYear, DateFormats.US)})`}
              </span>
            </div>
            <GenericList>
              <GenericListItem>
                <Row className={'w-100'}>
                  <Col
                    className={
                      'col-3 col-lg-6 text-dark-gray text-sm-12-lg-14 fw-normal'
                    }
                  >
                    {'Account'}
                  </Col>
                  <Col className={'col-3 col-lg-2 text-dark text-sm-12-lg-14'}>
                    {'Total'}
                  </Col>
                  <Col className={'col-2 col-lg-2 text-dark text-sm-12-lg-14'}>
                    {'YTD'}
                  </Col>
                  <Col
                    className={
                      'col-4 col-lg-2 text-dark text-sm-12-lg-14 text-end pe-0'
                    }
                  >
                    {'Balance'}
                  </Col>
                </Row>
              </GenericListItem>
              <GenericListItem>
                <Row className={'w-100'}>
                  <Col
                    className={
                      'col-3 col-lg-6 text-dark-gray text-sm-12-lg-14 fw-normal'
                    }
                  >
                    {'Dependent Care FSA'}
                  </Col>
                  <Col
                    className={'col-3 col-lg-2 text-dark-gray text-sm-12-lg-14'}
                  >
                    {formatPrice(5000.0)}
                  </Col>
                  <Col
                    className={'col-3 col-lg-2 text-dark-gray text-sm-12-lg-14'}
                  >
                    {formatPrice(5000.0)}
                  </Col>
                  <Col
                    className={
                      'col-3 col-lg-2 text-dark-gray text-sm-12-lg-14 text-end pe-0'
                    }
                  >
                    {formatPrice(56.0)}
                  </Col>
                </Row>
              </GenericListItem>
            </GenericList>
            <div className={'mt-10'}>
              <Blockquote variant="transperant">
                <Fragment>
                  <div className={'text-darker-gray-75'}>
                    <strong>Did you know?</strong>
                  </div>
                  <div className={'mt-2 text-ligther-grey'}>
                    You only have until <strong>March 31st</strong> to submit
                    FSA expenses for last year or you will lose the available
                    funds (as required by the IRS){' '}
                    <span className={'d-inline-block'}>
                    <Link className={'py-0'} isBlue onClick={() => {
                        openExternalLink('https://qa.mybenefitwallet.com/BW/');
                        }}>
                        Submit Claim
                      </Link>
                    </span>
                  </div>
                </Fragment>
              </Blockquote>
            </div>
          </GenericCard>

        </Col>

        <Col sm={12} lg={4} className={'d-flex flex-column order-1 order-lg-2 mt-11 mt-lg-0'}>
          <div>

          <GenericCard
              onClick={() => openExternalLink('https://www.mybenefitwallet.com/CMS/portal/default/index.html')}
              className={'doc-upload p-5 cursor-pointer'}
              variant={'white'}
            >
              <div
                className={'carousel-img-container rounded-1 overflow-hidden'}
              >
                <img
                  className={'w-100 h-auto'}
                  src={`${process.env.PUBLIC_URL}/${'company6.png'}`}
                  alt={`${process.env.PUBLIC_URL}/${'company6.png'}`}
                />
              </div>
              <div className="mt-4 lh-xs fw-light">
                <h6 className="mb-0 text-sm-16-lg-20">BenefitWallet</h6>
              </div>
              <div className="lh-xxs fw-light text-sub1 text-light-grey-normal">
                <span>View your historical information</span>
              </div>
            </GenericCard>
            </div>

           
        </Col>
        
      </Row>

    </Container>
  );
}

function Dashboard() {
  return (
    <HssProvider>
      <HealthSavingsAndSpendingChannelView />
    </HssProvider>
  );
}

export default Dashboard;
